import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { fetchProducts } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => { fetchProducts().then(setProducts).catch(() => {}); }, []);

  const categories = ["All", ...Array.from(new Set(products.map((p) => p.category)))];
  const visible = filter === "All" ? products : products.filter((p) => p.category === filter);

  return (
    <div data-testid="shop-page" className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-primary">Shop</span>
        <h1 className="mt-3 font-heading text-4xl font-semibold tracking-tighter text-[#FAFAFA] sm:text-5xl">
          Cooling shrouds & accessories
        </h1>
        <p className="mt-4 max-w-xl text-base text-[#A1A1AA]">
          Everything you need to run your Miner quieter, cooler, and faster.
        </p>
      </motion.div>

      <div className="mt-10 flex flex-wrap gap-3">
        {categories.map((c) => (
          <button
            key={c}
            data-testid={`filter-${c}`}
            onClick={() => setFilter(c)}
            className={`rounded-sm border px-4 py-2 text-sm transition-colors ${
              filter === c
                ? "border-primary bg-primary text-[#09090B]"
                : "border-[#27272A] text-[#A1A1AA] hover:border-primary hover:text-primary"
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {visible.map((p, i) => (
          <ProductCard key={p.id} product={p} index={i} />
        ))}
      </div>
    </div>
  );
};

export default Shop;
